import _ from "underscore";
import $ from "clients/RawClient";
import ActionTypes from "actions/action-types.js";
import { createAction } from "redux-actions";

const actions = {
  loadingMemberhipRentalBegin: createAction(ActionTypes.LOADING_MEMBERSHIP_RENTAL_BEGIN),
  fetchMembershipRentalBeginSuccess: createAction(ActionTypes.FETCH_MEMBERSHIP_RENTAL_BEGIN_SUCCESS),

  fetchMembershipRentalBegin: zipCode => {
    return dispatch => {
      dispatch(actions.loadingMemberhipRentalBegin(true));
      $.get(`/membershipRentalBegin/${zipCode}`)
        .then(
          function (membershipRentalBegin) {
            if (!membershipRentalBegin || _.isEmpty(membershipRentalBegin)) {
              return;
            }

            const rentBeginDate = _.first(membershipRentalBegin).rentBegin;
            dispatch(actions.fetchMembershipRentalBeginSuccess(rentBeginDate));
          },
          () => {}
        )
        .finally(function () {
          dispatch(actions.loadingMemberhipRentalBegin(false));
        });
    };
  },
};

export default actions;

export const { loadingMemberhipRentalBegin, fetchMembershipRentalBeginSuccess, fetchMembershipRentalBegin } = actions;
